import { PolicyComponentProps } from "../../types";

import MarkdownLayout from "../../_components/MarkdownLayout";
import EnDocument from "./en.md";
import KoDocument from "./ko.md";

export default function TermsOfUse241220({
  language,
  layoutSize,
}: PolicyComponentProps) {
  return (
    <MarkdownLayout size={layoutSize}>
      {language === "ko" && <KoDocument />}

      {language === "en" && <EnDocument />}
    </MarkdownLayout>
  );
}
